import React from "react";
import "./../Styles/Policy.css";

export default function Policy() {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <div className="policy-header">
          <h1>Privacy Policy</h1>
          <p className="website">www.embroiderybazar.in</p>
          <p className="last-update">
            Last Updated: <strong>July 18, 2026</strong>
          </p>
        </div>

        <section className="policy-section">
          <h2>Introduction</h2>
          <p>
            At <strong>Embroidery Bazar</strong>, we are committed to protecting
            the privacy and security of our visitors and customers. This Privacy
            Policy explains how we collect, use, and protect your information.
          </p>
        </section>

        <section className="policy-section">
          <h2>1. Information We Collect</h2>

          <div className="policy-card">
            <h3>Personal Information</h3>
            <ul>
              <li>Name</li>
              <li>Email Address</li>
              <li>Mobile Number</li>
              <li>Billing Address</li>
            </ul>
          </div>

          <div className="policy-card">
            <h3>Transaction Information</h3>
            <p>
              We collect purchase-related information to process your orders.
              Payment card details are securely processed by payment gateways
              and are <strong>never stored on our servers.</strong>
            </p>
          </div>
        </section>

        <section className="policy-section">
          <h2>2. How We Use Your Information</h2>

          <ul>
            <li>Process and manage your orders.</li>
            <li>Provide digital downloads.</li>
            <li>Send invoices and receipts.</li>
            <li>Respond to customer support requests.</li>
            <li>Notify you about important account updates.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>3. Data Sharing</h2>

          <p>
            We never sell or rent your personal information. Your information is
            shared only with trusted payment gateways and when required by law.
          </p>
        </section>

        <section className="policy-section">
          <h2>4. Data Security</h2>

          <p>
            We implement appropriate security measures to safeguard your
            personal information against unauthorized access, disclosure, or
            misuse.
          </p>
        </section>

        <section className="policy-section">
          <h2>5. Your Rights</h2>

          <ul>
            <li>Access your personal information.</li>
            <li>Update or correct your information.</li>
            <li>Request deletion of your account data.</li>
            <li>Contact us for privacy-related concerns.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>6. Changes to this Privacy Policy</h2>

          <p>
            We may update this Privacy Policy from time to time. Any changes
            will become effective immediately after being published on this
            page.
          </p>
        </section>

        <section className="policy-section">
          <h2>Contact Us</h2>

          <div className="contact-box">
            <p>
              <strong>Email</strong>
            </p>
            <p>embroiderybazar05@gmail.com</p>

            <hr />

            <p>
              <strong>Office Address</strong>
            </p>

            <p>
              Shop No: 17/UGF, Ranuja Complex,
              <br />
              Near Riddhi Siddhi School,
              <br />
              Vallabhacharya Road,
              <br />
              Ashvanikumar,
              <br />
              Surat - 395008,
              <br />
              Gujarat, India.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}
